import { render } from "./TheBody.vue?vue&type=template&id=e4df0ba8&scoped=true"
import script from "./TheBody.vue?vue&type=script&lang=js"
export * from "./TheBody.vue?vue&type=script&lang=js"

import "./TheBody.vue?vue&type=style&index=0&id=e4df0ba8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4df0ba8"]])

export default __exports__